import { ErrorHandler, Injectable } from "@angular/core";
@Injectable()
export class AppErrorHandler implements ErrorHandler {
    count: number = 0;
    handleError(error) {
        if (this.count == 0) { console.log('Dentbox', error); this.count++; }
    }
}